<template>
  <div class="row">
    <div class="col-md-12">
      <dashboard-box :back="true" back-component-name="management.role_scopes.index">
        <template v-slot:title>
          <span>{{ $t("roles.self") }}</span>
        </template>
        <template v-slot:preview>
          <b-row>
            <b-col lg="6" md="6" sm="12" xl="6">
              <b-form-group :label="$t('roles.name')">
                <b-form-input
                    v-model="form.name"
                    :placeholder="$t('roles.name')"
                    :state="validateState('name')"
                    class="form-control form-control-solid"
                    name="name"
                    type="text"
                ></b-form-input>
                <b-form-invalid-feedback
                    v-if="!validateState('name') && !$v.form.name.required"
                    :state="true">
                  {{ $t('roles.validations.name.required') }}
                </b-form-invalid-feedback>
              </b-form-group>
            </b-col>

            <b-col lg="6" md="6" sm="12" xl="6">
              <b-form-group :label="$t('roles.description')">
                <b-form-input
                    v-model="form.description"
                    :placeholder="$t('roles.description')"
                    :state="validateState('description')"
                    class="form-control form-control-solid"
                    name="description"
                    type="text"
                ></b-form-input>
                <b-form-invalid-feedback
                    v-if="!validateState('description') && !$v.form.description.required"
                    :state="true">
                  {{ $t('roles.validations.description.required') }}
                </b-form-invalid-feedback>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>



            <template v-for="(scope_group, group_name) in scopes">
              <b-col lg="6" md="6" sm="12" xl="6">
                <div class="card card-box">
                  <div class="card-body">
                    <h4 class="card-title">{{ $t('scope.' + group_name.toLowerCase()) }}</h4>
                          <b-form-checkbox-group
                              id="checkbox-group-2"
                              v-model="form.selectedScope" inline
                              name="scopes">
                            <b-form-checkbox v-for="scope in scope_group" :value="scope.id" :key="scope.id">
                              {{ $t('scope.' + scope.action) }}
                            </b-form-checkbox>
                          </b-form-checkbox-group>
                    </div>
                </div>
              </b-col>
            </template>

            <b-col
                class="float-right text-right"
                lg="12"
                md="12"
                sm="12"
                xl="12"
            >
              <b-button
                  class="mr-1"
                  variant="secondary"
                  @click="goBack"
              >
                <i class="fas fa-arrow-left"></i>
                {{ $t("general.cancel") }}
              </b-button>
              <b-button variant="primary" @click="createOrUpdate()">
                <i class="far fa-save"></i>
                {{ $t(id != null ? "general.save" : "general.create") }}
              </b-button>
            </b-col>
          </b-row>
        </template>
      </dashboard-box>
    </div>
  </div>
</template>

<script>
import DashboardBox from "@/assets/components/DashboardBox";
import {SET_BREADCRUMB} from "@/core/services/store/breadcrumbs.module";
import baseModule, {
  BASE_URL,
  CREATE_ITEM,
  ERROR,
  GET_ITEM,
  GET_SCOPES,
  ITEM,
  LOADING,
  MODULE_NAME as BASE_MODULE,
  SCOPES,
  SUCCESS,
  UPDATE_ITEM
} from "@/core/services/store/role.module";

import store from "@/core/services/store";
import MultipleSelectInput from "@/assets/components/inputs/MultipleSelectInput";
import _ from "lodash";
import {validationMixin} from "vuelidate";
import {required} from "vuelidate/lib/validators";

const _BASE_MODULE = BASE_MODULE;

export default {
  name: "RolesCreateEdit",
  mixins: [validationMixin],
  beforeCreate() {
    function registerStoreModule(moduleName, storeModule) {
      if (!(store && store.state && store.state[moduleName])) {
        store.registerModule(moduleName, storeModule);
      }
    }

    registerStoreModule(_BASE_MODULE, baseModule);
  },
  components: {
    DashboardBox,
    MultipleSelectInput,
  },
  validations: {
    form: {
      name: {
        required
      },
      description: {
        required
      }
    }
  },
  computed: {
    error() {
      return store.getters[_BASE_MODULE + "/" + ERROR];
    },
    loading() {
      return store.getters[_BASE_MODULE + "/" + LOADING];
    },
    success() {
      return store.getters[_BASE_MODULE + "/" + SUCCESS];
    },
    item() {
      return store.getters[_BASE_MODULE + "/" + ITEM];
    },
    scopes() {
      return store.getters[_BASE_MODULE + "/" + SCOPES] || [];
    },
  },
  data() {
    return {
      id: null,
      form: {
        name: '',
        description: '',
        selectedScope: [],
      }
    };
  },
  methods: {
    goBack() {
      this.$router.push({name: "management.role-scopes.index"})
    },
    validateState(name) {
      const {$dirty, $error} = this.$v.form[name];
      return $dirty ? !$error : null;
    },
    getItem() {
      this.$store
          .dispatch(_BASE_MODULE + "/" + GET_ITEM, {
            url: BASE_URL + "/" + this.id,
          })
    },
    getScopes() {
      this.$store
          .dispatch(_BASE_MODULE + "/" + GET_SCOPES, {})
    },
    createOrUpdate() {
      let formData = _.clone(this.form);

      if (this.id) {
        this.$store
            .dispatch(_BASE_MODULE + "/" + UPDATE_ITEM, {
              url: BASE_URL + '/' + this.id,
              contents: formData
            });
      } else {
        this.$store
            .dispatch(_BASE_MODULE + "/" + CREATE_ITEM, {
              contents: formData,
            });
      }
    },
  },
  mounted() {
    this.id = this.$route.params.id;
    this.getScopes();

    if (this.id != null) {
      this.getItem();
    }
    this.$store.dispatch(SET_BREADCRUMB, [
      {title: this.$t("general.dashboard"), route: "dashboard"},
      {title: this.$t(this.id ? "roles.edit_item" : "roles.create_item")},
    ])
  },
  watch: {
    item(value) {
      if (value && value.item) {
        value = value.item;
        let tmpArray = [];
        value.scopes.map(item => {
          tmpArray.push(item.id);
        })
        this.form.name = value.name;
        this.form.description = value.description;
        this.form.selectedScope = tmpArray;
      }
    },
    success(value) {
      let self = this;
      if (value) {
        setTimeout(() => {
          self.sweetAlertSuccess(self.$t("general.successfully_saved"),
              (response) => {
                if (response) {
                  self.$router.push({name: "management.roles.index"});
                }
              });
        }, 500)
      }
    }
  }
}
</script>

<style scoped>
#dashboard-box {
  padding: 10px;
}

.example-code {
  position: inherit !important;
  left: 0 !important;
  right: 0 !important;
  opacity: 1 !important;
}

.example .example-preview {
  padding: 10px 5px;
}

.example-preview i {
  padding-left: 5px;
}

.example-preview span {
  padding-left: 10px;
  font-size: 16px;
}

.card-box {
  border: 1px solid #DFE3E7;
  border-radius: 0.267rem;
}

body.dark-layout .card-box {
  border: 1px solid #464d5c;
  border-radius: 0.267rem;
}

</style>
